module.exports = __webpack_public_path__ + "img/cloudy-storm.02fb956.svg";